// BUG-257: Admin 목록 상단 Priority 칩 ↔ RayTable 스냅샷(IMP-307, ListStateReducer) 동기화 헬퍼.
// RayTable 은 재마운트 때 스냅샷의 filterpage 를 복원하므로, 칩이 바뀌면 스냅샷의 priority 도 같이 맞춰야 한다.
// priorityKey: 서비스 'priority', 에러 'errs.priority'. 칩 '없음' 은 빈 문자열 값(키는 존재)이다.

// 스냅샷에 저장된 priority 칩 값 → 페이지의 priorityFilter 초기값. 없으면 {}(All).
export const readPriorityFilter = (snapshot, priorityKey) => {
	const filters = snapshot?.filterpage?.filters;
	if (!filters || typeof filters !== 'object' || !(priorityKey in filters)) return {};
	const value = filters[priorityKey];
	return value === undefined || value === null ? {} : { [priorityKey]: value };
};

// 새 priorityFilter 를 반영한 스냅샷 패치({ filterpage }). 다른 필터·검색어는 보존, page 는 1, All({})은 키 제거.
// 스냅샷(filterpage)이 없으면 RayTable 이 options.filterpageoption 으로 시작하므로 null(저장 불필요).
export const buildPrioritySnapshotPatch = (snapshot, priorityKey, priorityFilter) => {
	const saved = snapshot?.filterpage;
	if (!saved || typeof saved !== 'object') return null;
	const { [priorityKey]: _dropped, ...others } = saved.filters || {};
	return {
		filterpage: {
			...saved,
			filters: { ...others, ...(priorityFilter || {}) },
			page: 1,
		},
		// RayTable 은 currentPage 를 filterpage.page 와 별도로 복원한다 — 같이 1로 맞춘다.
		currentPage: 1,
	};
};
